<template>
  <span :class="{ 'text-secondary': isOpened }" @click="toggle">
    <span class="fas fa-search"></span>
    <portal to="header" v-if="isOpened">
      <AlgoliaSearch
        :hits-per-page="hitsPerPage"
        :placeholder="placeholder"
        :show-close="true"
        @close="dismiss"
      ></AlgoliaSearch>
    </portal>
  </span>
</template>
<script>
import AlgoliaSearch from './AlgoliaSearch';
export default {
  name: 'SearchButton',
  components: { AlgoliaSearch },
  props: {
    hitsPerPage: {
      type: Number,
      default: 5,
    },
    placeholder: {
      type: String,
      default: 'Search the site',
    },
  },
  data() {
    return {
      isOpened: false,
    };
  },
  created() {
    const handler = event => {
      if (event.key === 'Escape' && this.isOpened) {
        this.dismiss();
      }
    };

    document.addEventListener('keydown', handler);

    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', handler);
    });
  },
  methods: {
    toggle() {
      this.isOpened = !this.isOpened;
    },
    dismiss() {
      this.isOpened = false;
    },
  },
};
</script>
